import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";

import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import Table from 'react-bootstrap/Table';
import  red from '../images/red.png'
import green from '../images/green.png'
import arrow from '../images/arrow.png'
// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";
import UniqueAppliYearToDate from '../database/UniqueAppliYearToDate.json'
import UniqueApplibyMonth from '../database/UniqueApplibyMonth.json'
import Header from "./Header";


export const ApplicationsDetails3 = () => {
 const [ttl, setttl]=useState(0);
  

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1
  };

  function checkPer(per){
    if(per > +25){
      return (<img src={green} width='20px' height='20px'/>);
    }else if(per < +25 && per > 0){
      return (<img src={arrow} width='20px' height='20px'/>);
    }else{
      return (
        <img src={red} width='20px' height='20px'/>
        );
    }
  }

  useEffect(()=>{
    userAppliAdd();
  },[])



  function userAppliAdd(){
    const rec = UniqueApplibyMonth
    var sum=0;
      for(var i=0; i<rec.length; i++){
        sum += parseInt(rec[i].AppliN)
      }
      setttl(sum)
      
      
      

  }


  
 

  return (
    <React.Fragment>
    <Header/>
      <Container fluid style={{height:'100%'}}>
        <Row>
          <Col>
            <Container fluid>
              <Row>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "40px" }}>
                    <strong>&nbsp; Applications Details</strong>
                  </h2>
                </Col>
                
                <Col
                  xs={3}
                  
                  
                >
                  <Card
                    className="text-center"
                    style={{
                      
                      boxShadow: "2px 2px 8px ",
                      position:'initial',
                       height: "80px",
                       width: "220px",
                       marginTop: '3px',
                       marginLeft: "52px",
                  
                    }}
                  >
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white",padding:'0px' }}
                    >
                      Total Unique Applications
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <h1>903</h1>
                    </Card.Body>
                  </Card>
                  </Col>
                  
                  <Col xs={3}>
                  <Card
                    className="text-center"
                    style={{
                      height: "80px",
                      width: "210px",
                      boxShadow: "2px 2px 8px ",
                      marginTop:'3px',
                      position:'initial',
                    }}
                  >
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black",padding:'0px' }}
                    >
                      All Applications
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      
                            <h1>2617</h1>




                    </Card.Body>
                    </Card>
                  </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
                position:'initial',
              }}
            ></hr>
          </Col>
        </Row>
        <Row>
          

          <Col xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px " ,position:'initial'}}>
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px' }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial'
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px' }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
         
          
          
          <Col xs={3}>
          <Card style={{ boxShadow: "2px 2px 8px ", width: "300px",position:'initial' }}>
            <Card.Header style={{ color: "white", backgroundColor: "black" ,padding:'0px'}}>
              Select Lead Stage
            </Card.Header>
            <Card.Body style={{ paddingTop: "0px", position:'initial',paddingBottom: "0px" ,height:'45px'}}>
              
              <Slider {...settings} className='slider'>
                  <div style={{position:'initial'}} >
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2017</Button>
                  </div>
                  <div style={{position:'initial'}}>
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2019</Button>
                  </div>
                  <div >
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2020</Button>
                  </div>
                  <div >
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2021</Button>
                  </div>
                  <div >
                    <Button variant="secondary" style={{padding:'0px',position:'initial'}}>2022</Button>
                  </div>
                  
                    
                  
                </Slider>
              
            </Card.Body>
          </Card>
        </Col>
        <Col xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position:'initial',
                position:'initial'
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black",padding:'0px' }}>
                Select Destination
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                >
                  <option>All</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row style={{display:'flex',justifyItems:'center',marginTop:'5px'}}>
        <Col>
              <Card style={{backgroundColor:'brown',width:'300px',height:'30px',left:'300px',textAlign:'center'}}>
             <strong style={{fontSize:'20px'}}> Total Applications</strong></Card>
             
              
        </Col>
        
        <Col>
        <Card style={{backgroundColor:'brown',width:'300px',height:'30px',textAlign:'center'}}><strong style={{fontSize:'20px'}}>Unique Applications</strong></Card>
        </Col>
        </Row>
        <Row style={{paddingTop:'4px'}}>
        <Col xs={5}>
        <Card style={{boxShadow: "2px 2px 8px "}}>
        <Card.Header style={{backgroundColor:'black',color:'white',textAlign:'center',padding:'0px'}}>Unique Applications By Month</Card.Header>
        <Card.Body style={{padding:'3px', height:'334px'}} >
        
        <div>
        
        <Table responsive="sm" style={{margin:'0px'}}>
        <thead>
          <tr>
            <th>Month</th>
            <th>Unique Application</th>
            <th>M-o-M</th>
            <th>Change</th>
            <th>Year-To-Date</th>
            
          </tr>
        </thead>
        <tbody style={{fontSize:'12px'}}>
        {
            

          UniqueApplibyMonth.map((user => (
            <tr>
            <td>{user.month}</td>
            <td>{user.AppliN}</td>
            <td>{
                
                   checkPer(user.per)
            }
            </td>
            <td>{user.per}%</td>
            <td>{user.Ytd}</td>
           
            
            
            
          </tr>
          
          
          

          

            
          )))
        }
        
        <tr style={{backgroundColor:'Highlight'}}>
        <td><strong>Total:</strong></td>
        <td><strong>{ttl}</strong>
        </td>
        <td></td>
        <td></td>
        <td><strong>{ttl}</strong></td>
        </tr>
        
          
          
        </tbody>
      </Table>
      
      
        
        </div>

        </Card.Body>
        </Card>
        
        </Col>
        <Col xs={7}>

        <Card style={{boxShadow: "2px 2px 8px ", height:'358px',position:'initial'}}>
        <Card.Header style={{backgroundColor:'black',color:'white',textAlign:'center',padding:'0px'}}>Unique Applications Year-To-Date</Card.Header>
              <Card.Body>
              <LeadsByMonthGraph color="green" graphType="waterfall" db={UniqueAppliYearToDate} height={300}/>
              
              </Card.Body>
        </Card>
        
        </Col>
        </Row>
        </Container>
        </React.Fragment>
  )
        }

        export default ApplicationsDetails3;